import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Box,
  CircularProgress,
  Button,
  Paper,
  styled
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import AutorenewIcon from '@mui/icons-material/Autorenew'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import SaveIcon from '@mui/icons-material/Save'
import Navigation from '../components/navigation'
import StepsContainer from './Steps'
import Info from './Info'

import {
  clearedWorkflowAction,
  executeWorkflow,
  saveWorkflow,
  toggledAddNewStepAction
} from '../../../store/pages/common/workflow'

import {
  validateFields,
  isOneStepChecked,
  validateStepFields
} from './validation'

export default function Workflow () {
  const dispatch = useDispatch()
  const desc = useSelector((state) => state.workflow.desc)
  const guid = useSelector((state) => state.workflow.guid)
  const isExecuting = useSelector((state) => state.workflow.isExecuting)
  const isSaving = useSelector((state) => state.workflow.isSaving)
  const name = useSelector((state) => state.workflow.name)
  const steps = useSelector((state) => state.workflow.steps)

  const hasId = guid !== undefined && guid !== null && guid !== ''

  const Form = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2),
    width: '100%',
    overflow: 'visible',
    shadow: 'none',
    border: 'none',
    backgroundColor: 'white'
  }))

  const isExecuteDisabled =
    validateFields(desc, name, steps) ||
    isSaving ||
    isExecuting ||
    !isOneStepChecked(steps) ||
    validateStepFields(steps)

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
      <Box mb={2}>
        <Navigation />
      </Box>
      <Form elevation={0}>
        <Box px={2}>
          <Box mb={3}>
            <Info />
          </Box>

          <Box mb={3} display="flex" flexWrap="wrap" gap={2}>
            {isSaving
              ? (
              <CircularProgress />
                )
              : (
              <Button
                data-testid="button-save/update"
                disabled={validateFields(desc, name, steps) || isExecuting}
                variant="contained"
                color="secondary"
                onClick={() => dispatch(saveWorkflow)}
                startIcon={<SaveIcon />}
              >
                {hasId ? 'UPDATE' : 'SAVE'}
              </Button>
                )}

            <Button
              data-testid="button-newWorkflow"
              disabled={validateFields(desc, name, steps) || isExecuting}
              variant="outlined"
              color="primary"
              onClick={() => dispatch(clearedWorkflowAction)}
              startIcon={<AutorenewIcon />}
            >
              New Workflow
            </Button>
          </Box>

          <Box mb={3}>
            {steps.map((value, index) => (
              <StepsContainer
                key={index}
                uniqueKey={index}
                view={value}
                order={index}
                isExecuting={isExecuting}
                isSaving={isSaving}
              />
            ))}
          </Box>

          <Box display="flex" gap={2} alignItems="center">
            <Button
              data-testid="button-addStep"
              disabled={isSaving || isExecuting}
              variant="outlined"
              color="primary"
              onClick={() => dispatch(toggledAddNewStepAction)}
              startIcon={<AddIcon />}
            >
              Add Step
            </Button>

            {isExecuting
              ? (
              <CircularProgress size={25} />
                )
              : (
              <Button
                data-testid="button-execute"
                variant="contained"
                color="secondary"
                disabled={isExecuteDisabled}
                onClick={() => dispatch(executeWorkflow)}
                startIcon={<PlayArrowIcon />}
              >
                Execute
              </Button>
                )}
          </Box>
        </Box>
      </Form>
    </Box>
  )
}
